var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.list.length)?_c(_setup.MarvinInfoBox,{attrs:{"text":_setup.t('project-forum.apply-box.profile-check', {
    list: _setup.list}),"mood":"concerned"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }